import { render, staticRenderFns } from "./AddBrandVoiceByText.vue?vue&type=template&id=5219e35d"
import script from "./AddBrandVoiceByText.vue?vue&type=script&lang=js"
export * from "./AddBrandVoiceByText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports